<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">settings</v-icon>
            {{ userData.email }}
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_user" data-vv-scope="edit_user" lazy-validation>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <!-- <v-flex xs5 style="margin: auto;">
                User credits*:
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  class="flex-attribute-input"
                  v-model="credits"
                  persistent-hint
                  v-validate="`required|integer`"
                  data-vv-name="edit_user.credits"
                  :error-messages="errors.collect('edit_user.credits')"
                >
                <template v-slot:append-outer>
                  {{$store.state.metadata.currencySign[$store.state.metadata.currencies[userData.currency]]}}
                </template>
                </v-text-field>
              </v-flex> -->
              <v-flex xs5 style="margin: auto;">
                User Package*:
              </v-flex>
              <v-flex xs7>
                <v-select
                  :items="plans"
                  v-model="form.package_id"
                  item-text="product.description"
                  item-value="product.package_id"
                ></v-select>
              </v-flex>
              <template v-if="selectedPackage">
                <template v-for="attribute in selectedPackage.flexible_attributes">
                  <v-flex xs5 :key="attribute.product.id" style="margin: auto;">
                    <span>{{attribute.product.description.replace('Stock','')}}:</span>
                  </v-flex>
                  <v-flex xs7 :key="attribute.product.id + '_'">
                    <v-text-field
                      class="flex-attribute-input"
                      v-model="flexibleAttributes[attribute.product.name]"
                      :hint="`Available from ${attribute.min_count} to ${attribute.max_count_without_stock >= 0 ? attribute.max_count_without_stock : '∞'}`"
                      :disabled="attribute.max_count === 0"
                      persistent-hint
                      v-validate="`required|min_value: ${attribute.min_count}` + (attribute.max_count_without_stock > 0 ? `|max_value:${attribute.max_count_without_stock}` : '')"
                      :data-vv-name="'edit_user.' + attribute.product.name"
                      :error-messages="errors.collect('edit_user.' + attribute.product.name)"
                    ></v-text-field>
                  </v-flex>
                </template>
              </template>
              <v-flex xs5 style="margin: auto;">
                Expire Date*:
              </v-flex>
              <v-flex xs7>
                <v-menu
                  :close-on-content-click="false"
                  v-model="dateMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFormatted"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                  <v-date-picker
                    v-model="form.expiry_date"
                    :first-day-of-week="$store.state.user.first_day_of_week"
                    @input="dateMenu = false"
                    min="1990-01-01"
                    required
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                10Club reports*:
              </v-flex>
              <v-flex xs7 pt-3>
                <template v-for="report in tenClubReportsList">
                  <v-checkbox
                    v-if="report.ten_club"
                    :key="report.id"
                    v-model="form.ten_club_reports"
                    :label="report.description"
                    :value="report.id"
                    class="pt-0 mt-0"
                  ></v-checkbox>
                </template>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Subscription auto renew*:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-checkbox
                  v-model="form.subscription_renew"
                  label=""
                  class="pt-0 mt-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs5 style="margin: auto;">
                Note:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-textarea
                  v-model="form.admin_note"
                  rows="3"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-btn color="orange" @click="resetPermissions()" class="white--text" :disabled="userData.overridden_permissions ? false : true">Reset permissions</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveChanges()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditUserModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editUserDialog', 'userData', 'loading'],
  data () {
    return {
      dialog: this.editUserDialog,
      plans: [],
      credits: this.userData.credits,
      flexibleAttributes: {
        projects_extra: 0,
        keywords_extra: 0,
        reports_extra: 0,
        links_extra: 0,
        history_extra: 0
      },
      userSubscription: null,
      tenClubReportsList: this.$store.state.metadata.reportsById,
      form: {
        package_id: 0,
        keywords_extra: 0,
        projects_extra: 0,
        links_extra: 0,
        reports_extra: 0,
        history_extra: 0,
        expiry_date: '',
        ten_club_reports: this.userData && this.userData.ten_club_reports ? this.userData.ten_club_reports : [],
        subscription_renew: this.userData && this.userData.subscription_renew ? this.userData.subscription_renew : false,
        admin_note: this.userData && this.userData.admin_note ? this.userData.admin_note : ''
      },
      selectedPackage: null,
      selectedPackageIndex: null,
      plansIndexes: {},
      currentDate: new Date().toISOString().substr(0, 10),
      dateMenu: false,
      rules: {
        required: value => (!!value || value === 0) || 'Required.'
      },
      dictionary: {
        en: {
          custom: {
            'edit_user.max_projects': {
              required: 'Max projects count required',
              integer: 'Only numbers allowed'
            },
            'edit_user.max_keywords': {
              required: 'Max keywords count required',
              integer: 'Only numbers allowed'
            },
            'edit_user.max_links': {
              required: 'Max links count required',
              integer: 'Only numbers allowed'
            },
            'edit_user.credits': {
              required: 'Credits count required',
              integer: 'Only numbers allowed'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.getPackages()
  },
  watch: {
    editUserDialog: {
      handler () {
        this.dialog = this.editUserDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editUserDialog', this.dialog)
      }
    },
    'form.package_id': {
      handler () {
        this.selectedPackage = this.plans[this.plansIndexes[this.form.package_id]]
        this.setFlexibleAttributes()
        if (this.userSubscription && this.selectedPackage.product.package_id === this.userSubscription.package_id) {
          Object.keys(this.flexibleAttributes).forEach(index => {
            if (this.userSubscription[index]) {
              this.flexibleAttributes[index] = this.flexibleAttributes[index] + this.userSubscription[index]
            }
          })
        }
        this.compileErrors()
        // this.$validator.errors.clear()
      }
    }
  },
  computed: {
    dateFormatted () {
      return this.form.expiry_date ? this.$moment(this.form.expiry_date).format('DD-MM-YYYY') : ''
    }
  },
  methods: {
    getPackages () {
      this.$parent.$emit('loading', true)
      this.$store.dispatch('GET_PACKAGES').then(res => {
        let packages = this.removeStockFromName(res.packages)
        this.plans = packages
        this.plans.forEach((element, index) => {
          this.plansIndexes[element.product.package_id] = index
        })
        if (this.form.package_id) {
          this.selectedPackage = this.plans[this.plansIndexes[this.form.package_id]]
        } else {
          this.selectedPackage = packages[0]
        }
        this.setFlexibleAttributes()
        this.compileErrors()
        this.$parent.$emit('loading', false)
        this.getUserSubscription()
      }, err => {
        this.$parent.$emit('loading', false)
        console.log('GET_PACKAGES error', err)
        this.$toasted.show('GET_PACKAGES Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    getUserSubscription () {
      this.$parent.$emit('loading', true)
      this.$store.dispatch('GET_USER_SUBSCRIPTION', this.userData.id).then(res => {
        if (res.subscription) {
          this.userSubscription = res.subscription
          this.form.package_id = res.subscription.package_id
          this.form.expiry_date = res.subscription.expiry_date
        }
        this.$parent.$emit('loading', false)
      }, err => {
        console.log('GET_USER_SUBSCRIPTION ERROR', err)
        this.$parent.$emit('loading', false)
        this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    saveChanges () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          let params = this.prepareSubscriptionParams()

          // if (parseFloat(this.userData.credits) !== parseFloat(this.credits)) {
          //   this.changeUserBalance()
          // }
          if (!this.$services.compareArrays(this.form.ten_club_reports, this.userData.ten_club_reports) ||
            this.userData.subscription_renew !== this.form.subscription_renew ||
            this.userData.admin_note !== this.form.admin_note) {
            this.saveUser()
          }

          this.$store.dispatch('SET_USER_SUBSCRIPTION', { userId: this.userData.id, params: params }).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateUsersList')
            this.$toasted.show('User subscription was successfully edited')
            this.closeModal()
          }, err => {
            console.log('SET_USER_SUBSCRIPTION error', err)
            this.$parent.$emit('loading', false)
            this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    changeUserBalance () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          let params = {
            currency_type: this.userData.currency,
            amount: this.getDiff(),
            user_id: this.userData.id
          }
          this.$store.dispatch('CHANGE_USER_CREDITS', params).then(res => {
            this.$parent.$emit('loading', false)
            this.$toasted.show('User balance was successfully changed')
          }, err => {
            console.log('CHANGE_USER_CREDITS error', err)
            this.$parent.$emit('loading', false)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    getDiff () {
      let diff = Math.abs(parseFloat(this.credits) - parseFloat(this.userData.credits))
      if (parseFloat(this.credits) < parseFloat(this.userData.credits)) diff = diff * (-1)
      return diff
    },
    saveUser () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          let params = {
            ten_club_reports: this.form.ten_club_reports || [],
            subscription_renew: this.form.subscription_renew,
            admin_note: this.form.admin_note
          }
          this.$store.dispatch('EDIT_USER', { userId: this.userData.id, newData: params }).then(res => {
            this.$parent.$emit('loading', false)
            this.$toasted.show('User was successfully edited')
            this.closeModal()
          }, err => {
            console.log('EDIT_USER error', err)
            this.$parent.$emit('loading', false)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    prepareSubscriptionParams () {
      let params = {
        package_id: this.form.package_id,
        expiry_date: this.form.expiry_date
      }
      this.selectedPackage.flexible_attributes.map((attribute) => {
        params[attribute.product.name] = this.flexibleAttributes[attribute.product.name] - attribute.min_count
      })
      return params
    },
    removeStockFromName (packages) {
      packages = packages.map(item => {
        item.flexible_attributes = item.flexible_attributes.map(attribute => {
          attribute.product.name = attribute.product.name.replace('_stock', '')
          return attribute
        })
        return item
      })
      return packages
    },
    setFlexibleAttributes () {
      this.selectedPackage.flexible_attributes.map((flexibleAttribute) => {
        this.flexibleAttributes[flexibleAttribute.product.name] = flexibleAttribute.current_count ? flexibleAttribute.current_count : flexibleAttribute.min_count
      })
    },
    resetPermissions () {
      this.$parent.$emit('loading', true)
      this.$store.dispatch('RESET_USER_PERMISSIONS', this.userData.id).then(res => {
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateUsersList')
        this.$toasted.show('User settings were set to default')
        this.closeModal()
      }, err => {
        console.log('RESET_USER_PERMISSIONS ERROR', err)
        this.$parent.$emit('loading', false)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    compileErrors () {
      this.dictionary.en.custom = {
        'edit_user.projects_extra': {
          required: 'Projects count required',
          min_value: `Minimum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[0].min_count : ''} projects`,
          max_value: `Maximum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[0].max_count_without_stock : ''} projects`
        },
        'edit_user.keywords_extra': {
          required: 'Keywords count required',
          min_value: `Minimum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[1].min_count : ''} keywords`,
          max_value: `Maximum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[1].max_count_without_stock : ''} keywords`
        },
        'edit_user.reports_extra': {
          required: 'Reports count required',
          min_value: `Minimum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[2].min_count : ''} reports`,
          max_value: `Maximum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[2].max_count_without_stock : ''} reports`
        },
        'edit_user.links_extra': {
          required: 'Links count required',
          min_value: `Minimum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[3].min_count : ''} links`,
          max_value: `Maximum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[4].max_count_without_stock : ''} links`
        },
        'edit_user.history_extra': {
          required: 'History count required',
          min_value: `Minimum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[4].min_count : ''} weeks`,
          max_value: `Maximum ${this.selectedPackage ? this.selectedPackage.flexible_attributes[4].max_count_without_stock : ''} weeks`
        }
      }
      this.$validator.localize(this.dictionary)
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>

<style type="css">
.permissions-checkboxes .v-input--selection-controls .v-input__slot, .permissions-checkboxes .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
}
.permissions-checkboxes .v-input--selection-controls .v-messages {
  min-height: 0px;
}
</style>
<style scoped>
.permission-subheader {
  font-family: "Source Sans Pro", sans-serif;
  color: #656565;
  font-weight: bold;
}
.permissions-checkboxes .v-input.v-input--selection-controls {
    margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/EditUserModal.vue